import * as React from "react";

import TooltipCell from "./ToolTipCell"

export default ({}) => {
    return <TooltipCell text={"Anonym"}/>
}